import React, { Component, Fragment } from 'react'
import { Layout } from 'app/common/layout'
import type { EventMetadata } from 'shared/store/metadata'
import { eventsDefinitions } from 'shared/store/metadata'
import styled from 'styled-components'
import CarouselElement from 'nuka-carousel'
import { tiles } from './tiles'
import { Tile } from './Tile'
import { Baseline } from './Baseline'
import { SliderNavigation } from './SliderNavigation'
import { CSSTransition } from 'react-transition-group'
import { FormattedMessage } from 'react-intl'
import {
    breakpoints,
    ButtonSmall,
    media,
    ResponsiveContainer
} from 'app/assets/styles'
import { H1, H2, Text } from 'app/common/typography'
import mobile_histoire from 'app/assets/images/timeline/timeline-mobile.jpg'
import desktop_histoire from 'app/assets/images/timeline/timeline-desktop.jpg'
import Responsive from 'react-responsive'

type Props = {
    sendMeta: EventMetadata => void,
    fetchPageData: () => void
}

type State = {
    slideIndex: number,
    showSlider: boolean,
    tilesSize: number,
    animation: string
}

class TimelineComponent extends Component<Props, State> {
    state = {
        slideIndex: 0,
        showSlider: false,
        tilesSize: tiles.length,
        animation: ''
    }

    componentDidMount() {
        this.props.fetchPageData()
    }
    handleClick = () => {
        const meta = {
            ...eventsDefinitions['TIMELINE_DISCOVER']
        }
        this.props.sendMeta(meta)

        this.setState({ showSlider: true })
    }

    previous = (index: number) => {
        if (index === 0) {
            this.setState({
                showSlider: false
            })
            return
        }

        index--

        const meta = {
            ...eventsDefinitions['TIMELINE_PREV'],
            event_action: index.toString()
        }
        this.props.sendMeta(meta)
        this.setState({
            slideIndex: index,
            animation: 'previous'
        })
    }

    next = (index: number) => {
        index++
        if (index === this.state.tilesSize) {
            return
        }
        const meta = {
            ...eventsDefinitions['TIMELINE_NEXT'],
            event_action: index.toString()
        }
        this.props.sendMeta(meta)
        this.setState({
            slideIndex: index,
            animation: 'next'
        })
    }

    render() {
        const timeout = 600
        const breakpoint = breakpoints.medium
        const { slideIndex, showSlider, tilesSize, animation } = this.state
        const sliderNavigations = {
            slideIndex: slideIndex,
            tilesSize: tilesSize,
            previous: () => this.previous(slideIndex),
            next: () => this.next(slideIndex)
        }
        const tilesRender = tiles.map((tile, index) => (
            <Tile key={index} index={index === slideIndex} {...tile} />
        ))

        return (
            <Layout>
                {showSlider ? (
                    <Fragment>
                        <Responsive maxWidth={breakpoint - 1}>
                            <Mobile>
                                <Carousel
                                    className="hide"
                                    cellSpacing={28}
                                    cellAlign={'center'}
                                    dragging={false}
                                    slideIndex={slideIndex}
                                    afterSlide={slideIndex =>
                                        this.setState({ slideIndex })
                                    }
                                    slideWidth={'278'}
                                    slide>
                                    {tilesRender}
                                </Carousel>
                                <SliderNavigation {...sliderNavigations} />
                            </Mobile>
                        </Responsive>
                        <Responsive minWidth={breakpoint}>
                            <Desktop>
                                <Content>
                                    <ResponsiveContainer>
                                        <LeftBlock>
                                            <Baseline />
                                            <TextViewport>
                                                {tiles.map((tile, index) => (
                                                    <CSSTransition
                                                        in={
                                                            index === slideIndex
                                                        }
                                                        key={index}
                                                        unmountOnExit
                                                        timeout={timeout}
                                                        classNames="fade">
                                                        <StyledText>
                                                            {tile.story}
                                                        </StyledText>
                                                    </CSSTransition>
                                                ))}
                                            </TextViewport>
                                            <SliderNavigation
                                                {...sliderNavigations}
                                            />
                                        </LeftBlock>
                                    </ResponsiveContainer>
                                </Content>
                                <Col />
                                <Col>
                                    {tiles.map((tile, index) => (
                                        <CSSTransition
                                            in={index === slideIndex}
                                            key={index}
                                            unmountOnExit
                                            timeout={timeout}
                                            classNames="fade">
                                            <Image
                                                src={tile.images.desktop}
                                                alt={tile.title}
                                            />
                                        </CSSTransition>
                                    ))}
                                </Col>
                                <TileViewport>
                                    {tiles.map((tile, index) => (
                                        <CSSTransition
                                            in={index === slideIndex}
                                            key={index}
                                            unmountOnExit
                                            timeout={timeout}
                                            classNames={animation}
                                            compon>
                                            <Tile {...tile} />
                                        </CSSTransition>
                                    ))}
                                </TileViewport>
                            </Desktop>
                        </Responsive>
                    </Fragment>
                ) : (
                    <Fragment>
                        <Responsive maxWidth={breakpoint - 1}>
                            <MobileContainer>
                                <HomeMobile>
                                    <FormattedMessage id="timeline.baseline">
                                        {(text: string) => (
                                            <StyledH1>{text}</StyledH1>
                                        )}
                                    </FormattedMessage>
                                    <FormattedMessage id="timeline.subBaseline">
                                        {(text: string) => (
                                            <StyledH2>{text}</StyledH2>
                                        )}
                                    </FormattedMessage>
                                    <FormattedMessage id="timeline.button">
                                        {(text: string) => (
                                            <ButtonSmall
                                                onClick={this.handleClick}>
                                                {text}
                                            </ButtonSmall>
                                        )}
                                    </FormattedMessage>
                                </HomeMobile>
                                <ImageMobile
                                    width={'100%'}
                                    src={mobile_histoire}
                                />
                            </MobileContainer>
                        </Responsive>
                        <Responsive minWidth={breakpoint}>
                            <Desktop>
                                <Content>
                                    <ResponsiveContainer>
                                        <HomeDesktop>
                                            <Baseline />
                                            <ButtonSmall
                                                width={'100%'}
                                                onClick={this.handleClick}>
                                                <FormattedMessage id="timeline.button" />
                                            </ButtonSmall>
                                        </HomeDesktop>
                                    </ResponsiveContainer>
                                </Content>
                                <Col />
                                <Col>
                                    <Image
                                        src={desktop_histoire}
                                        alt={desktop_histoire}
                                    />
                                </Col>
                            </Desktop>
                        </Responsive>
                    </Fragment>
                )}
            </Layout>
        )
    }
}

const HomeMobile = styled(ResponsiveContainer)`
    text-align: center;
    text-transform: uppercase;
    margin: 100px auto auto auto;
    z-index: 2;
`

const HomeDesktop = styled.div`
    max-width: 360px;
    margin: 0;
`

const LeftBlock = styled.div`
    max-width: 360px;
    margin-top: 100px;
    ${media.large`
        margin-top: 0;
    `};
`

const ImageMobile = styled.img`
    width: ${props => props.width};
    position: relative;
`

const MobileContainer = styled.section`
    overflow: hidden;
    -webkit-overflow-scrolling: touch;
    line-height: 0;
`

const Desktop = styled.section`
    display: flex;
    position: relative;
    overflow: hidden;
`

const Mobile = styled.section`
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    overflow: hidden;
`

const Carousel = styled(CarouselElement)`
    margin: auto;
`

const Content = styled.div`
    position: absolute;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
`

/*FIX: Overwriting font-size for better display on iPad devices*/
const StyledText = styled(Text)`
    ${media.medium`
        font-size: 16px;
        line-height: 24px;
    `};
    ${media.large`
        font-size: 18px;
        line-height: 30px;
    `};
`

const TextViewport = styled.div`
    position: relative;
    top: 0;
    left: 0;
    width: auto;
    height: 100px;

    ${media.large`
        height: 150px;
    `}


    ${Text}, ${StyledText} {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
    };
`
const TileViewport = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    overflow: hidden;
    width: 24vw;
    height: 36vw;
    max-width: 310px;
    max-height: 600px;
    min-height: 350px;
    transform: translate(-50%, -50%);
    perspective: 1200px;
`

const StyledH1 = styled(H1)`
    margin-bottom: 10px;
`
const StyledH2 = styled(H2)`
    margin-bottom: 30px;
`
const Image = styled.img`
    width: 50vw;
    height: 100%;
`
const Col = styled.div`
    flex-basis: 50%;
    height: 50vw;
    overflow: hidden;
`

export { TimelineComponent }
